
        function filterTable() {
    var aircraft = document.getElementById("aircraftFilter").value;
    var documentType = document.getElementById("documentFilter").value;
    var rows = document.querySelectorAll("#documentTable tbody tr");
    var table = document.getElementById("documentTable");
    var visibleRows = 0;

    rows.forEach(row => {
        if (row.hasAttribute("data-fixed")) {
            row.style.display = "table-row";
            visibleRows++;
            return;
        }

        // Clean & split data
        var rowAircraft = (row.getAttribute("data-aircraft") || "")
            .split(",")
            .map(v => v.trim());
        var rowDocument = (row.getAttribute("data-document") || "")
            .split(",")
            .map(v => v.trim());

        // If no filters selected, hide everything except fixed rows
        if (aircraft === "" && documentType === "") {
            row.style.display = "none";
            return;
        }

        // Filtering logic
        var matchAircraft = aircraft === "" || rowAircraft.includes(aircraft);
        var matchDocument = documentType === "" || rowDocument.includes(documentType);

        if (matchAircraft && matchDocument) {
            row.style.display = "table-row";
            visibleRows++;
        } else {
            row.style.display = "none";
        }
    });

    // Show table only if visible rows (including fixed rows) exist
    table.style.display = visibleRows > 0 ? "table" : "none";
}
